<script>
export default {
  data() {
    return {
      loadChildComponentPromise: null,
      isRecordSearchCondition: false,
      saveSearchConditionKey: 'SearchCondition'
    }
  },
  computed: {},
  mounted() {
    this.componentOnMounted(this.$children)
  },
  methods: {
    searchOnClick() {
      // 每次点击搜索的时候存储搜索条件，保证还原后，搜索结果与上次一致
      this.fetchData()
      this.recordSearchCondition()
    },
    componentOnMounted($children) {
      // 因为列表页与搜索项相关的子组件不会发生变化，所以初始化时获取一次Form组件对应的Controller就可以了
      // this.getAllFormComponentController($children)
      this.loadCompleteCallback()
    },
    routerOnEnter(to, from) {
      this.routeName = to.name
      this.isRecordSearchCondition = true

      this.loadCompleteCallback(from)
    },
    loadCompleteCallback(fromRoute) {
      if (this.loadChildComponentPromise) {
        this.loadChildComponentPromise.then(from => {
          this.restoreSearchCondition(from || fromRoute)
          // 启动默认展示数据
          this.searchOnClick()
        })
      } else {
        this.loadChildComponentPromise = Promise.resolve(fromRoute)
      }
    },
    restoreSearchCondition(from) {
      // 是否是从详情页跳转过来的
      // if (!from.name || from.name.indexOf('详情') === -1) {
      const parentName = from.meta.parentName
      // 路由配置的父节点是否与当前路由名称一致
      if (parentName !== this.routeName) {
        return
      }
      // }

      const searchCondition = this.getStoreCondition()
      Object.keys(searchCondition).forEach(key => {
        this.searchForm[key] = searchCondition[key]
      })
    },
    recordSearchCondition() {
      if (!this.isRecordSearchCondition) {
        return
      }

      const searchCondition = {}
      Object.keys(this.searchForm).forEach(key => {
        // 不再只记录value，记录全部信息，方便还原
        searchCondition[key] = this.searchForm[key] // .value
      })
      this.storeCondition = searchCondition
      this.setStoreCondition(this.storeCondition)
    },
    getStoreCondition() {
      let searchCondition = sessionStorage.getItem(this.saveSearchConditionKey)
      try {
        searchCondition = JSON.parse(searchCondition)
        if (!searchCondition || typeof searchCondition !== 'object') {
          searchCondition = {}
        }
      } catch (error) {
        searchCondition = {}
      }

      return searchCondition[this.routeName] || {}
    },
    setStoreCondition(value) {
      // 因为只有一种情况需要还原搜索条件：从当前列表点击进入对应的详情页返回时，还原当前模块的搜索条件，进入其他列表页不需要还原
      // 所以每次只记录当前路由对应的搜索条件
      const searchCondition = {
        [this.routeName]: value
      }
      sessionStorage.setItem(
        this.saveSearchConditionKey,
        JSON.stringify(searchCondition)
      )
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routerOnEnter(to, from)
    })
  }
}
</script>

<style lang="scss">
</style>
